import { PLUS_SHIPPING_COST } from '@conversion/constants';
import getCart from './getCart';

const getCartIsPlusDiscountApplied = state => {
  const discounts = getCart(state)?.discounts || [];
  return discounts.some(discount => discount.type === PLUS_SHIPPING_COST);
};

export default getCartIsPlusDiscountApplied;
